var FileDownload = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

FileDownload.prototype.init = function(){

  let $downloadLink = this.options.$el;

  $downloadLink.on('click', function() {

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'download_pdf',
		event_category: 'engagement'
	});

  });

};

export default  FileDownload;
